import { ConditionTypeSelect as SharedConditionTypeSelect } from '@/features/dryad';
import { peopleSearchConditionTypeOf } from './condition-types';

type ConditionTypeSelectProps = {
  nodeId: string;
  currentType: string;
};

/**
 * The people surface's binding of the shared condition-type select: supplies
 * this surface's builder handle and its allowed-type narrowing, so the rows
 * keep passing only the node they render.
 */
export function ConditionTypeSelect({ nodeId, currentType }: ConditionTypeSelectProps) {
  return (
    <SharedConditionTypeSelect
      nodeId={nodeId}
      currentType={currentType}
      conditionTypeOf={peopleSearchConditionTypeOf}
    />
  );
}
